import FixedAssetAPI from './_fixedAssetApi.js';
import httpClient from '@/apis/base/httpclient';
class fADevaluationListAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FaDevaluations';

  /**
   * Hàm get dữ liệu trích khấu hao
   * @param {*} payload
   * @returns
   *
   */
  async getDataFADevaluation(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataFaDevaluation',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
}

export default new fADevaluationListAPI();
